"use client";

import { ChevronRight as ArrowRightIcon } from "lucide-react";
import Button from "@components/Button";
import Flag from "@components/Flag";
import type { NavigationLink } from "@components/header/types";
import { useMarket } from "@features/market/useMarket";
import { MobileMenuContext } from "@context/mobileMenuContext";
import { useContext, useMemo } from "react";

import { cn } from "@/lib/utils";

export default function MarketSelectorButton({
  className,
}: {
  className?: string;
}) {
  const market = useMarket();
  const { setNavigationTree, setNavigationDirection } =
    useContext(MobileMenuContext);

  const flag = market.countryCode;

  const text = useMemo(() => market.countryName, [market.countryName]);

  return (
    <Button
      className={cn("[&>*:first-child]:hidden", className)}
      onClick={() => {
        setNavigationTree((prev) => [
          ...prev,
          {
            type: "Market",
            slug: "",
            title: "",
          } satisfies NavigationLink,
        ]);
        setNavigationDirection("right");
      }}
      endIcon={
        <ArrowRightIcon strokeWidth={1} className="ml-auto size-4 md:hidden" />
      }
    >
      <Flag
        code={flag}
        className={cn(
          "mr-1 h-3 w-3 flex-none grow-0 rounded-full border border-black object-cover",
        )}
      />
      <span data-testid="market-selector-dropdown-country-name">{text}</span>
    </Button>
  );
}
